import React from "react";
import "../styles/_almarehotel.scss";
interface Props {}

const AlMareHotelGR: React.FC<Props> = (props) => {
  return (
    <div className="AlMareHotel container padding100" id="theHotel">
      <div className="row align-items-center">
        <div className="col-lg-6 col-12">
          <h6 className="text-start">AL-MARE</h6>
          <h1 className="text-start">ΤΟ ΞΕΝΟΔΟΧΕΙΟ</h1>
          <p>
            Το Al-Mare Hotel *** Superior βρίσκεται στην Κασσάνδρα, το πρώτο από
            τα τρία πόδια της Χαλκιδικής, μία από τις δημοφιλέστερες τουριστικές
            περιοχές της Ανατολικής Μεσογείου.
            <br /> <br />
            Το Al Mare Hotel είναι ένας εξελιγμένος τουριστικός προορισμός.
            Βρίσκεται σε ιδανική τοποθεσία δίπλα στην ακτή της θάλασσας και
            περιβάλλεται από ηρεμία, γαλήνη και μυρωδιά του πευκόδασου. Η
            Θεσσαλονίκη και το αεροδρόμιο της Θεσσαλονίκης βρίσκονται σε
            απόσταση 85 χιλιομέτρων, ενώ το μικρό γραφικό ελληνικό χωριό
            Πολύχρονο σε απόσταση περίπου 2 χιλιομέτρων.
            <br /> <br />
            Το Al-Mare Hotel προσφέρει εξαιρετικές δυνατότητες για
            διακοπές,μακριά από την καλοκαιρινή συμφόρηση αλλά και για
            εξερεύνηση των γύρω περιοχών, λουτρά και ανέγγιχτη φύση. Παρ` όλα
            αυτά αν επιθυμείτε διακοπές με περισσότερη αναψυχή, στη γύρω περιοχή
            βρίσκεται και η ζώνη των νυχτερινών κέντρων και ταβερνών-
            παραδοσιακά ελληνικά εστιατόρια.
            <br /> <br />
            Οι εργαζόμενοι στο Al Mare βλέπουν τον κάθε επισκέπτη του
            ξενοδοχείου ως φιλοξενούμενο στο σπίτι τους!
            <br /> <br />
            <span>Η Al-Mare Ομάδα</span>
          </p>
        </div>
        <div className="col-lg-6 col-12">
          <div className="row">
            <div className="col-lg-6 col-12">
              <img src="hotel1.jpg" alt="" className="w-100 bottomImg" />
            </div>
            <div className="col-lg-6 col-12">
              <img src="hotel2.jpg" alt="" className="w-100 topImg" />
            </div>
            <div className="col-lg-6 col-12">
              <img src="dream.jpg" alt="" className="w-100 upImg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlMareHotelGR;
